var map = {
	"./1remix.svg": 947,
	"./2stenciljs.svg": 845,
	"./3mparticle.svg": 922,
	"./4shippable.svg": 362,
	"./5atom.svg": 810,
	"./6terraform.svg": 64,
	"./7rackspace.svg": 396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 850;